import React, { useState } from 'react';
import { Button } from '@ohif/ui';

const ChatWindow = () => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');

    const handleSendMessage = () => {
        const trimmedMessage = newMessage.trim();
        if (trimmedMessage) {
            setMessages([
                ...messages,
                {
                    id: messages.length + 1,
                    text: trimmedMessage,
                    sender: 'User',
                    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                },
            ]);
            setNewMessage('');
        }
    };

    const handleSuggestionClick = suggestion => {
        setMessages([
            ...messages,
            {
                id: messages.length + 1,
                text: suggestion,
                sender: 'User',
                timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            },
        ]);
    };

    return (
        <div className="chat-window flex flex-grow flex-col p-4" style={{ background: 'var(--bg-surface)' }}>
            <div className="mb-4 rounded p-3" style={{ background: 'rgba(245, 158, 11, 0.12)', color: 'var(--text-primary)' }}>
                ⚠️ <span className="ml-2">Rad AI currently in an experimental phase</span>
            </div>
            {messages.length === 0 ? (
                <div className="relative bottom-16 flex flex-grow flex-col items-center justify-end space-y-4">
                    <div className="flex flex-wrap justify-center gap-4">
                        {[
                            'Patient Count',
                            'Patient Details',
                            'Patient Medical History',
                            'Appointment Schedule',
                            'Prescribed Medications',
                            'Test Results',
                            'Insurance Information',
                        ].map(suggestion => (
                            <button
                                key={suggestion}
                                // onClick={() => handleSuggestionClick(suggestion)}
                                className="rounded-full px-6 py-2 shadow-sm transition duration-150 ease-in-out focus:outline-none focus:ring-[3px]"
                                style={{
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    padding: '0.5rem 1.25rem',
                                    color: 'var(--text-primary)',
                                    background: 'var(--bg-hover)',
                                    border: '1px solid var(--border-subtle)',
                                }}
                                onMouseEnter={e => { e.currentTarget.style.background = 'var(--primary-25)'; e.currentTarget.style.borderColor = 'var(--primary-200)'; }}
                                onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg-hover)'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; }}
                            >
                                {suggestion}
                            </button>
                        ))}
                    </div>
                </div>
            ) : (
                <div
                    className="mb-4 flex flex-grow flex-col overflow-y-auto"
                    style={{ height: 'calc(100vh - 345px)' }}
                >
                    {messages.map(msg => (
                        <div
                            key={msg.id}
                            className="flex justify-end"
                        >
                            <div
                                className={`mb-4 rounded-[var(--radius-md)] p-3 shadow-sm`}
                                style={{
                                    maxWidth: '40%',
                                    wordBreak: 'break-word',
                                    minWidth: '40%',
                                    background: msg.sender === 'User' ? 'var(--primary-25)' : 'var(--bg-hover)',
                                    border: '1px solid var(--border-subtle)',
                                }}
                            >
                                <div className="text-sm" style={{ color: 'var(--text-primary)' }}>{msg.text}</div>
                                <div className="mt-1 text-right text-[13px]" style={{ color: 'var(--text-muted)' }}>{msg.timestamp}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <div className="flex items-center border-t p-2" style={{ borderColor: 'var(--border-subtle)' }}>
                <input
                    type="text"
                    placeholder="Ask Rad AI something..."
                    className="flex-1 rounded-full border p-2"
                    style={{ borderColor: 'var(--border-subtle)', background: 'var(--bg-card)', color: 'var(--text-primary)' }}
                    value={newMessage}
                    onChange={e => setNewMessage(e.target.value)}
                //   onKeyDown={e => e.key === 'Enter' && handleSendMessage()}
                />
                <Button
                    className="ml-2 h-[20px] rounded-full p-2 text-white focus:outline-none"
                //   onClick={handleSendMessage}
                >
                    Send
                </Button>
            </div>
        </div>
    );
};

export default ChatWindow;
